import * as React from 'react';
import { Trash } from '@phosphor-icons/react';
import type { CanonicalSource } from '@/lib/governance/derive-canonical-source';
import s from './canonical-sources.module.scss';

export function sourceLabel(source: CanonicalSource) {
  return source.kind === 'npm' ? source.specifier : source.path;
}

export function SourceIdentity({ source }: { source: CanonicalSource }) {
  const label = sourceLabel(source);
  return (
    <>
      <span className={s.kindBadge} data-kind={source.kind}>
        {source.kind === 'npm' ? 'npm' : 'dir'}
      </span>
      <span className={s.specifier} title={label}>
        {label}
      </span>
    </>
  );
}

export interface CanonicalSourceRowProps {
  source: CanonicalSource;
  onRemove: () => void;
  disabled?: boolean;
}

export function CanonicalSourceRow({
  source,
  onRemove,
  disabled = false,
}: CanonicalSourceRowProps) {
  const [confirming, setConfirming] = React.useState(false);
  const label = sourceLabel(source);
  const excludeCount = source.exclude?.length ?? 0;

  if (confirming) {
    return (
      <div className={s.row}>
        <div className={s.removeConfirm}>
          <span className={s.removeConfirmText}>
            Remove this source? Migration suggestions from it will stop
            appearing.
          </span>
          <button
            type="button"
            className={s.removeConfirmBtn}
            data-variant="danger"
            onClick={() => {
              onRemove();
              setConfirming(false);
            }}
            disabled={disabled}
          >
            Remove
          </button>
          <button
            type="button"
            className={s.removeConfirmBtn}
            onClick={() => setConfirming(false)}
          >
            Cancel
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className={s.row}>
      <SourceIdentity source={source} />
      {excludeCount > 0 && (
        <span className={s.excludeBadge}>{excludeCount} excluded</span>
      )}
      <button
        type="button"
        className={s.removeBtn}
        onClick={() => setConfirming(true)}
        disabled={disabled}
        title="Remove source"
        aria-label={`Remove source ${label}`}
      >
        <Trash size={14} />
      </button>
    </div>
  );
}
